import { create, show, useModal } from "@ebay/nice-modal-react";

import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";

import usePersonalApiKeysRevoke from "../useRevoke";

type PersonalApiKeysRevokeModalProps = {
  id: string;
  name: string;
  owner: string;
};

const PersonalApiKeysRevokeModal = create(function PersonalApiKeysRevokeModal({
  id,
  name,
  owner,
}: PersonalApiKeysRevokeModalProps) {
  const modal = useModal();
  const { revoke, loading } = usePersonalApiKeysRevoke();

  const handleConfirm = async () => {
    const isSuccess = await revoke(id);

    if (isSuccess) {
      modal.resolve();
      modal.hide();
    }
  };

  return (
    <DeleteConfirmationModal
      title="Revoke API key"
      onConfirm={handleConfirm}
      isLoading={loading}
      isDismissable={!loading}
      confirmationButtonLabel="Revoke"
    >
      <ConfirmationModalMessage>
        Revoking <strong>{name}</strong> stops it working immediately, so anything using it will
        fail to authenticate. {owner} will see it marked as revoked in their Personal API keys. This
        can&apos;t be undone.
      </ConfirmationModalMessage>
    </DeleteConfirmationModal>
  );
});

export const showPersonalApiKeysRevokeModal = (props: PersonalApiKeysRevokeModalProps) =>
  show(PersonalApiKeysRevokeModal, props);
